<div class="ce-page">

  <!-- Header -->
  <div class="ce-header">
    <a routerLink="/contractors" class="ce-back-link">
      <mat-icon>arrow_back</mat-icon> Contractors
    </a>
    <h1 class="ce-title">Edit Contractor</h1>
  </div>

  <!-- Loading skeleton -->
  <div class="ce-card" *ngIf="isLoading">
    <div class="ce-skeleton">
      <div class="sk-avatar-lg"></div>
      <div class="sk-field-group">
        <div class="sk-field"></div>
        <div class="sk-field"></div>
        <div class="sk-field sk-field-short"></div>
      </div>
    </div>
  </div>

  <!-- Edit form -->
  <div class="ce-card" *ngIf="!isLoading">
    <form (ngSubmit)="save()" #editForm="ngForm">

      <!-- Photo section -->
      <div class="ce-photo-section">
        <div class="ce-avatar-wrap">
          <img *ngIf="imagePreview" [src]="imagePreview" class="ce-avatar-img" alt="Profile photo">
          <div class="ce-avatar-initials" *ngIf="!imagePreview">{{ initials(contractor.name) }}</div>
        </div>

        <div class="ce-photo-actions">
          <div class="ce-contractor-preview-name">{{ contractor.name || 'New Contractor' }}</div>
          <div class="ce-contractor-preview-title">{{ contractor.jobTitle || 'No title set' }}</div>
          <div class="ce-photo-btns">
            <label class="ce-upload-btn" matRipple>
              <mat-icon>upload</mat-icon>
              {{ imagePreview ? 'Change Photo' : 'Upload Photo' }}
              <input type="file" accept="image/*" (change)="onFileSelected($event)" hidden>
            </label>
            <button mat-icon-button type="button" (click)="clearPhoto()"
                    *ngIf="imagePreview" matTooltip="Remove photo" class="ce-clear-btn">
              <mat-icon>delete</mat-icon>
            </button>
          </div>
        </div>
      </div>

      <mat-divider class="ce-divider"></mat-divider>

      <!-- Fields grid -->
      <div class="ce-section-label">Contact Information</div>
      <div class="ce-grid">

        <mat-form-field appearance="outline" class="ce-field-wide">
          <mat-label>Full Name</mat-label>
          <mat-icon matPrefix>person</mat-icon>
          <input matInput [(ngModel)]="contractor.name" name="name" required placeholder="First Last">
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Job Title / Trade</mat-label>
          <mat-icon matPrefix>work</mat-icon>
          <input matInput [(ngModel)]="contractor.jobTitle" name="jobTitle" required placeholder="e.g. Electrician">
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Cell Phone</mat-label>
          <mat-icon matPrefix>phone</mat-icon>
          <input matInput [(ngModel)]="contractor.cellPhone" name="cellPhone" type="tel" placeholder="(555) 000-0000">
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Email</mat-label>
          <mat-icon matPrefix>email</mat-icon>
          <input matInput [(ngModel)]="contractor.email" name="email" type="email" placeholder="name@example.com">
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Age</mat-label>
          <input matInput [(ngModel)]="contractor.age" name="age" type="number" min="18" placeholder="e.g. 35">
        </mat-form-field>

      </div>

      <div class="ce-section-label">Compensation</div>
      <div class="ce-grid">

        <mat-form-field appearance="outline">
          <mat-label>Hourly Wage</mat-label>
          <mat-icon matPrefix>schedule</mat-icon>
          <span matSuffix>/hr</span>
          <input matInput [(ngModel)]="contractor.hourlyWage" name="hourlyWage" type="number" min="0" placeholder="0.00">
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Salary (annual)</mat-label>
          <mat-icon matPrefix>payments</mat-icon>
          <span matSuffix>/yr</span>
          <input matInput [(ngModel)]="contractor.salary" name="salary" type="number" min="0" placeholder="0">
        </mat-form-field>

      </div>

      <!-- Actions -->
      <div class="ce-actions">
        <button mat-stroked-button type="button" routerLink="/contractors">Cancel</button>
        <button mat-raised-button color="primary" type="submit"
                [disabled]="editForm.invalid || isSaving">
          <mat-icon>save</mat-icon>
          {{ isSaving ? 'Saving...' : 'Save Changes' }}
        </button>
      </div>

    </form>
  </div>

</div>
